export const contractAddress = {
  eth: '0xEae2926ae2d95984fF9Fbe309FC689d160E5089f',
  bsc: '0x09B80bD7a13F5B374a7A6c57600CC75F595e21c1'
} as const;

export const usdtAddress: Record<'eth' | 'bsc', `0x${string}`> = {
  eth: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
  bsc: '0x55d398326f99059fF775485246999027B3197955'
} as const;

export const usdcAddress: Record<'eth' | 'bsc', `0x${string}`> = {
  eth: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  bsc: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d'
} as const;

export const defaultReferral = '0x0000000000000000000000000000000000000000' as const;